import { render } from "./CalculatorSection.vue?vue&type=template&id=36f7f300&scoped=true"
import script from "./CalculatorSection.vue?vue&type=script&lang=js"
export * from "./CalculatorSection.vue?vue&type=script&lang=js"

import "./CalculatorSection.vue?vue&type=style&index=0&id=36f7f300&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f7f300"]])

export default __exports__